module.exports = __webpack_public_path__ + "static/media/blz.0ddb45f0.svg";